import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeAll12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconEdgeAll12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#EdgeAll12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M9.004 1.834a.5.5 0 1 0 0-1h-6a.5.5 0 0 0 0 1zM1.838 3a.5.5 0 1 0-1 0v6a.5.5 0 0 0 1 0zm9.331 0a.5.5 0 1 0-1 0v6a.5.5 0 0 0 1 0zm-1.665 7.666a.5.5 0 0 1-.5.5h-6a.5.5 0 1 1 0-1h6a.5.5 0 0 1 .5.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="EdgeAll12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconEdgeAll12);
